import { useEffect, useState } from 'react';
import { finApi } from '../../api/finance.js';
import { useAuth } from '../../contexts/AuthContext.jsx';

const TYPE_LABEL = { asset: 'Assets', liability: 'Liabilities', equity: 'Equity', revenue: 'Revenue', expense: 'Expense' };
const TYPE_COLOR = { asset: '#2563eb', liability: '#dc2626', equity: '#9333ea', revenue: '#16a34a', expense: '#ea580c' };

export default function ChartOfAccounts() {
  const { can } = useAuth();
  const canCreate = can('account', 'create');
  const [tree, setTree] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState(null);

  function refresh() {
    finApi.accountTree().then((d) => setTree(d?.tree || []));
    finApi.accountCategories().then((d) => setCategories(d || []));
  }
  useEffect(refresh, []);

  async function submit(e) {
    e.preventDefault();
    setError(null);
    const fd = new FormData(e.currentTarget);
    try {
      await finApi.createAccount({
        code: fd.get('code'),
        name: fd.get('name'),
        categoryId: fd.get('categoryId'),
        description: fd.get('description') || null,
      });
      e.currentTarget.reset();
      setShowForm(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed');
    }
  }

  return (
    <section>
      <header className="page-header">
        <h1>Chart of Accounts</h1>
        {canCreate && <button className="btn primary" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ New Account'}</button>}
      </header>

      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Code<input name="code" required placeholder="e.g. 6090" /></label>
          <label>Name<input name="name" required /></label>
          <label className="full">
            Category
            <select name="categoryId" required defaultValue="">
              <option value="" disabled>Select…</option>
              {categories.map((c) => <option key={c.id} value={c.id}>{TYPE_LABEL[c.type]} · {c.name}</option>)}
            </select>
          </label>
          <label className="full">Description<textarea name="description" rows={2} /></label>
          {error && <div className="alert error full">{error}</div>}
          <div className="full actions">
            <button type="submit" className="btn primary">Create</button>
          </div>
        </form>
      )}

      <div className="card">
        {tree.map((cat) => (
          <CategoryNode key={cat.id} cat={cat} />
        ))}
        {tree.length === 0 && <div className="muted">No accounts yet.</div>}
      </div>
    </section>
  );
}

function CategoryNode({ cat }) {
  return (
    <div className="coa-cat">
      <h3 style={{ borderLeftColor: TYPE_COLOR[cat.type] }}>
        <span className="muted small">{TYPE_LABEL[cat.type]}</span> {cat.name}
      </h3>
      <ul className="coa-list">
        {cat.children.map((a) => <AccountNode key={a.id} a={a} depth={0} />)}
        {cat.children.length === 0 && <li className="muted">— no accounts —</li>}
      </ul>
    </div>
  );
}

function AccountNode({ a, depth }) {
  return (
    <li style={{ paddingLeft: depth * 16 }}>
      <span className="acc-code">{a.code}</span>
      <span className="acc-name">{a.name}</span>
      {!a.is_active && <span className="chip status-cancelled small">archived</span>}
      {a.children?.length > 0 && (
        <ul className="coa-list">
          {a.children.map((c) => <AccountNode key={c.id} a={c} depth={depth + 1} />)}
        </ul>
      )}
    </li>
  );
}
